/* eslint-disable */
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';

export function SidebarLinks(props) {
  let location = useLocation();
  let activeColor = useColorModeValue('navy.800', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.700',
    'secondaryGray.500',
  );
  let activeIcon = useColorModeValue('brand.500', 'brand.300');
  let textColor = useColorModeValue('secondaryGray.700', 'secondaryGray.500');
  let brandColor = useColorModeValue('brand.500', 'brand.300');
  let activeBg = useColorModeValue(
    'rgba(111, 66, 193, 0.10)',
    'rgba(174, 134, 242, 0.16)',
  );

  const { routes, onNavigate } = props;

  const visibleAdminRoutes = routes.filter(
    (route) => route.layout === '/admin' && !route.invisible,
  );

  const activePath =
    visibleAdminRoutes.find(
      (route) => `${route.layout}${route.path}` === location.pathname,
    )?.path || null;

  const activeRoute = (routePath) => activePath === routePath;

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.invisible) {
        return null;
      }
      if (route.category) {
        return (
          <>
            <Text
              fontSize={'md'}
              color={activeColor}
              fontWeight="bold"
              mx="auto"
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              pt="18px"
              pb="12px"
              key={index}
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (route.layout === '/admin') {
        return (
          <NavLink
            key={index}
            to={route.layout + route.path}
            onClick={onNavigate}
          >
            {route.icon ? (
              <Box mb="10px" px="18px">
                <HStack
                  align="center"
                  spacing="12px"
                  py="14px"
                  px="16px"
                  minH="58px"
                  w="100%"
                  borderRadius="18px"
                  bg={activeRoute(route.path) ? activeBg : 'transparent'}
                  transition="all .2s ease"
                  _hover={{
                    bg: activeBg,
                    transform: 'translateX(2px)',
                  }}
                >
                  <Flex
                    w="100%"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Box
                      color={activeRoute(route.path) ? activeIcon : textColor}
                      flexShrink="0"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {route.icon}
                    </Box>
                    <Text
                      ms="2px"
                      me="auto"
                      color={activeRoute(route.path) ? activeColor : textColor}
                      fontWeight={activeRoute(route.path) ? '800' : '600'}
                      fontSize="md"
                    >
                      {route.name}
                    </Text>
                  </Flex>
                  <Box
                    h="24px"
                    w="4px"
                    bg={activeRoute(route.path) ? brandColor : 'transparent'}
                    borderRadius="5px"
                  />
                </HStack>
              </Box>
            ) : (
              <Box px="18px" mb="10px">
                <HStack
                  align="center"
                  spacing="12px"
                  py="14px"
                  px="16px"
                  minH="58px"
                  w="100%"
                  borderRadius="18px"
                >
                  <Text
                    me="auto"
                    color={
                      activeRoute(route.path) ? activeColor : inactiveColor
                    }
                    fontWeight={activeRoute(route.path) ? '800' : '600'}
                    fontSize="md"
                  >
                    {route.name}
                  </Text>
                  <Box h="36px" w="4px" bg="brand.400" borderRadius="5px" />
                </HStack>
              </Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
